import { BaseEntity } from "@app/models/rest/base-entity";
import { ValidationRule } from "@app/models/enums/validation-rule.enum";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("bookingReasons")
export class BookingReason extends BaseEntity {
  description: string;
  forceBookingReason: boolean;
  newBookingReason: boolean;
  amendBookingReason: boolean;
  referBookingReason: boolean;
  cancelBookingReason: boolean;
  noteValidation: ValidationRule;
}
